module.exports = __webpack_public_path__ + "img/m-2.8088f999.png";